module.exports = __webpack_public_path__ + "img/advances-Y.40bfe40d.svg";